import React from 'react'
import PropTypes from 'prop-types'

import SaleMethodImage from './assets/sale-method.jpg'

import ColumnTwo from '../ColumnTwo'
import styles from './styles.scss'

const auctionText = () => (
  <span>
    Auctions are an extremely effective method of generating strong competition, achieving maximum exposure through
    concentrated marketing and creating a sense of urgency due to the specified timeframe. They also determine the real
    value of a property in the current market. You set the reserve price, determine your campaign timing and work to a
    strategic, tailored plan. A firm date is set for the auction, the sky&apos;s the limit with the price and the sale
    is final upon the fall of the hammer.
  </span>
)

const expressionsText = () => (
  <span>
    This method is often used for unique properties that have little comparison, making pricing less straightforward,
    and is effective for gauging price interest. It is sometimes favoured by vendors not wanting to go to market with an
    advertised price but wanting an end date to create a sense of urgency.
  </span>
)

const privateTreatyText = () => (
  <span>
    With a private treaty sale there is no specified end date, so offers can be considered at your leisure. This is an
    effective method when you have no time pressure to sell. You set the price, determine the pace of the sales process
    and we negotiate with interested buyers, who have a cooling-off period once they make an offer.
  </span>
)

const renderSaleMethodDescription = ({ title }) => {
  if (title === 'Auction') return auctionText()
  if (title === 'Expressions of Interest') return expressionsText()
  if (title === 'Private Treaty') return privateTreatyText()
  return null
}

const renderBodyText = saleMethod => [
  <span key="intro">
    Working hand in hand with our tailored marketing campaigns, our recommended sales strategy best suits your unique
    property, your timeframe and the current market. After careful consideration, we believe that the most appropriate
    sales method to generate maximum competition and secure a premium price is: <strong>{saleMethod.title}</strong>
  </span>,
  <span key="heading" className={styles.saleMethodTitle}>{saleMethod.title}</span>,
  <span key="description">{renderSaleMethodDescription(saleMethod)}</span>,
]

const SaleMethod = (props) => {
  const { campaignSaleMethod } = props

  if (!campaignSaleMethod || !campaignSaleMethod.title) return null

  return (
    <ColumnTwo
      bodyText={renderBodyText(campaignSaleMethod)}
      title="Method of sale"
      greyBackground
      imageUrl={SaleMethodImage}
      reversed
    />
  )
}

SaleMethod.propTypes = {
  campaignSaleMethod: PropTypes.object.isRequired,
}

export default SaleMethod
